import React from "react"

const { Container , Row , Col  , Card , CardBody

} = require("reactstrap")
import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"
import { useQuery } from "react-query"
import { getEvents, getNotifications, getParentingSpaceUserList } from "helpers/fakebackend_helper"


const SpaceNotification = () => {

 
    const { data, isLoading } = useQuery('notification_list', getNotifications, {
        // staleTime: 120000,
          refetchOnWindowFocus: false,
        });
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags></MetaTags>
                <Container fluid className="w-100">
                    <Breadcrumbs title="Notifications" breadcrumbItem="Notifications" />

                    <Row>
                        <Col  >
                            <Card>
                                <CardBody>
                                    {isLoading ? (
                                        <div>Loading...</div>
                                    ) : !data?.notifications ? (
                                        <div>No users available.</div>
                                    ) : (
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className="table table-nowrap align-middle mb-0">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">ID</th>
                                                        <th scope="col">User</th>
                                                        <th scope="col">Notification</th>
                                                        <th scope="col">Email</th>
                                                        <th scope="col">Created At</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {data?.notifications.map(notification => (
                                                        <tr key={notification.id}>
                                                            <td>{notification.id}</td>
                                                            <td>{notification.created_by.name}</td>
                                                            <td>{notification.notification_message}</td>
                                                            <td>{notification.created_by.email}</td>
                                                            <td>{new Date(notification.created_at).toLocaleString()}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default SpaceNotification
